import React from 'react'
import styled from 'styled-components'

// Components

interface VideoProps {
  // eslint-disable-next-line camelcase
  video: string
}

const StyledIframe = styled.iframe`
  height: 500px;

  @media (max-width: 1199.98px) {
    height: 350px;
  }
  @media (max-width: 991.98px) {
  }
  @media (max-width: 767.98px) {
  }
  @media (max-width: 575.98px) {
    height: 200px;
  }
`

const Video: React.FC<VideoProps> = ({ video }) => (
  <section className="container">
    <div className="row mb-sm-5 justify-content-center pb-sm-5">
      <div className="col-lg-8 d-flex flex-column align-items-center justify-content-center">
        <StyledIframe
          src={video}
          width="100%"
          height="500"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Video"
          className="w-full"
        />
      </div>
    </div>
  </section>
)

export default Video
